import agendaApiConfig from "./agendaApiConfig";

const SucursalImagenologiaService = {
    async getAll () {
        let query =  {}; 
        if(process.env.REACT_APP_SERVICIO == ""){
            query = null;
        }else{
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO_IMG }; 
        }
        return await agendaApiConfig.get("/sucursal", {
            params: {
                ...query
            }
        });
    }
}

export default SucursalImagenologiaService;